
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { tokenIsExpired } from "../../authUtils";
import { Assessment, Receipt, Inventory, Settings, NotificationsActive } from "@mui/icons-material";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import { Card, CardContent, Button, Grid, Typography, Avatar, Box, IconButton, Alert } from "@mui/material";
import { fetchData, updateData, postData, deleteData } from '../../apiService';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SummarizeIcon from '@mui/icons-material/Summarize';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ArticleIcon from '@mui/icons-material/Article';
import NoteIcon from '@mui/icons-material/Note';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import BalanceIcon from '@mui/icons-material/Balance';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

import './Home.css';
// import { addMonths, subMonths, format, startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachDayOfInterval, isSameMonth, isToday } from "date-fns";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Modal,
    TextField,
    Select,
    CircularProgress,
} from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

function Home() {
    const { isAuthenticated, companyId, username, userId, logout, token, permissions, roleName } = useAuth();
    const [showReports, setShowReports] = useState(false);
    const [favorites, setFavorites] = useState([]);
    const { id } = useParams();
    const [dataItem, setDataItem] = useState([]);
    const [toDate, setToDate] = useState('');
    const [serviceReminders, setServiceReminders] = useState([]);
    const [serviceUpdateCount, setServiceUpdateCount] = useState(0);
    const [stampingUpdateCount, setStampingUpdateCount] = useState(0);
    const [dashboardStats, setDashboardStats] = useState({
        upcomingService: 0,
        upcomingStamping: 0,
        pendingService: 0,
        pendingStamping: 0,
        completedService: 0,
        completedStamping: 0,
        ordersForRenewal: 0
    });
    const [allServiceData, setAllServiceData] = useState([]);
    const [allStampingData, setAllStampingData] = useState([]);
    const [renewalOrdersData, setRenewalOrdersData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [modalTitle, setModalTitle] = useState('');
    const [modalType, setModalType] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [updateDates, setUpdateDates] = useState({});
    const [upcomingRenewals, setUpcomingRenewals] = useState({
        urgent: [],      // Expires in 7 days
        warning: [],     // Expires in 15 days
        upcoming: []     // Expires in 30 days
    });

    // Get greeting based on time
    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return { text: 'Good Morning', icon: '🌅' };
        if (hour < 17) return { text: 'Good Afternoon', icon: '☀️' };
        if (hour < 21) return { text: 'Good Evening', icon: '🌆' };
        return { text: 'Good Night', icon: '🌙' };
    };

    const greeting = getGreeting();

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const fetchServiceUpdates = async () => {
        try {
            const response = await fetchData('ReminderApi', `/ServiceUpdates/${companyId}`, token);
            console.log('Service Updates Response:', response);
            if (response && Array.isArray(response)) {
                setServiceUpdateCount(response.length);
                setAllServiceData(response); // Store for modal
                return response;
            } else {
                setServiceUpdateCount(0);
                setAllServiceData([]);
                return [];
            }
        } catch (error) {
            console.error('Error fetching service updates:', error);
            setServiceUpdateCount(0);
            setAllServiceData([]);
            return [];
        }
    };

    const fetchStampingUpdates = async () => {
        try {
            const response = await fetchData('ReminderApi', `/StampingUpdates/${companyId}`, token);
            console.log('Stamping Updates Response:', response);
            if (response && Array.isArray(response)) {
                setStampingUpdateCount(response.length);
                setAllStampingData(response); // Store for modal
                return response;
            } else {
                setStampingUpdateCount(0);
                setAllStampingData([]);
                return [];
            }
        } catch (error) {
            console.error('Error fetching stamping updates:', error);
            setStampingUpdateCount(0);
            setAllStampingData([]);
            return [];
        }
    };

    const fetchRenewalOrders = async () => {
        try {
            console.log('Fetching renewal orders for company:', companyId);
            console.log('API endpoint:', `/renewal/${companyId}`);
            
            const response = await fetchData('ReportAPI', `/renewal/${companyId}`, token);
            console.log('Renewal Orders Response:', response);
            
            // Handle both string and object responses
            let parsedResponse = response;
            if (typeof response === 'string') {
                try {
                    parsedResponse = JSON.parse(response);
                } catch (parseError) {
                    console.error('Error parsing response:', parseError);
                    setRenewalOrdersData([]);
                    return [];
                }
            }
            
            if (parsedResponse && parsedResponse.responseCode === '1111' && parsedResponse.response_data) {
                console.log('Renewal orders data:', parsedResponse.response_data);
                if (parsedResponse.response_data.length > 0) {
                    console.log('First renewal item structure:', parsedResponse.response_data[0]);
                    console.log('Available fields:', Object.keys(parsedResponse.response_data[0]));
                }
                setRenewalOrdersData(parsedResponse.response_data);
                return parsedResponse.response_data;
            } else {
                console.log('No renewal orders found or error response:', parsedResponse);
                setRenewalOrdersData([]);
                return [];
            }
        } catch (error) {
            console.error('Error fetching renewal orders:', error);
            console.error('Error details:', error.response?.data || error.message);
            console.error('Error status:', error.response?.status);
            setRenewalOrdersData([]);
            return [];
        }
    };

     


    const handleCardClick = (statusType) => {
        console.log('Card clicked:', statusType);
        let filteredData = [];
        let title = '';

        // Get service and stamping data separately
        const serviceData = allServiceData.map(item => ({ ...item, type: 'Service' }));
        const stampingData = allStampingData.map(item => ({ ...item, type: 'Stamping' }));
        
        console.log('Service data:', serviceData);
        console.log('Stamping data:', stampingData);

        // Filter based on specific card type
        if (statusType === 'upcomingService') {
            title = 'Upcoming Service Jobs';
            filteredData = serviceData.filter(item => {
                const statusValue = item.status ?? item.Status;
                if (item.isService === true || item.IsService === true) return false;
                return statusValue === 1 || (!statusValue && !item.IsService);
            });
        } else if (statusType === 'upcomingStamping') {
            title = 'Upcoming Stamping Jobs';
            filteredData = stampingData.filter(item => {
                const statusValue = item.status ?? item.Status;
                if (item.isStamping === true || item.IsStamping === true) return false;
                return statusValue === 1 || (!statusValue && !item.IsStamping);
            });
        } else if (statusType === 'pendingService') {
            title = 'Pending Service Jobs';
            filteredData = serviceData.filter(item => {
                const statusValue = item.status ?? item.Status;
                if (item.isService === true || item.IsService === true) return false;
                return statusValue === 2;
            });
        } else if (statusType === 'pendingStamping') {
            title = 'Pending Stamping Jobs';
            filteredData = stampingData.filter(item => {
                const statusValue = item.status ?? item.Status;
                if (item.isStamping === true || item.IsStamping === true) return false;
                if (statusValue === 2) return true;
                
                // Fallback logic for current month
                const currentMonth = new Date().getMonth();
                const currentYear = new Date().getFullYear();
                if (item.StampingToDate) {
                    const date = new Date(item.StampingToDate);
                    return date.getMonth() === currentMonth && date.getFullYear() === currentYear;
                }
                return false;
            });
        } else if (statusType === 'completedService') {
            title = 'Completed Service Jobs';
            filteredData = serviceData.filter(item => {
                const statusValue = item.status ?? item.Status;
                return (item.isService === true || item.IsService === true) || statusValue === 3;
            });
        } else if (statusType === 'completedStamping') {
            title = 'Completed Stamping Jobs';
            filteredData = stampingData.filter(item => {
                const statusValue = item.status ?? item.Status;
                return (item.isStamping === true || item.IsStamping === true) || statusValue === 3;
            });
        } else if (statusType === 'renewal') {
            title = 'Orders for Renewal';
            filteredData = renewalOrdersData.map(item => ({ ...item, type: 'Renewal' }));
        }

        console.log('Filtered data:', filteredData);
        console.log('Opening modal with title:', title);
        
        setModalTitle(title);
        // Determine base modal type for styling
        const baseModalType = statusType.includes('upcoming') ? 'upcoming' : 
                             statusType.includes('pending') ? 'pending' : 
                             statusType === 'renewal' ? 'renewal' : 'completed';
        setModalType(baseModalType);
        setModalData(filteredData);
        setSelectedItems([]);
        setUpdateDates({});
        setModalOpen(true);
    };

    const getUniqueKey = (item) => {
        // Use a combination that makes each row unique
        return `${item.type}-${item.Id}-${item.rowIndex}`;
    };

    const handleCheckboxChange = (item) => {
        const itemKey = getUniqueKey(item);
        console.log('Checkbox changed for:', itemKey, item);
        console.log('Current selected items:', selectedItems);
        
        setSelectedItems(prev => {
            const exists = prev.find(i => getUniqueKey(i) === itemKey);
            console.log('Item exists in selection:', exists);
            
            if (exists) {
                const newSelection = prev.filter(i => getUniqueKey(i) !== itemKey);
                console.log('Removing item, new selection:', newSelection);
                
                // Remove the date when unchecking
                setUpdateDates(prevDates => {
                    const dateKey = `${item.type}-${item.Id}-${item.rowIndex}`;
                    const newDates = { ...prevDates };
                    delete newDates[dateKey];
                    return newDates;
                });
                
                return newSelection;
            } else {
                const newSelection = [...prev, item];
                console.log('Adding item, new selection:', newSelection);
                
                // Auto-fill current date when checking
                const currentDate = new Date().toISOString().split('T')[0];
                const dateKey = `${item.type}-${item.Id}-${item.rowIndex}`;
                setUpdateDates(prevDates => ({
                    ...prevDates,
                    [dateKey]: currentDate
                }));
                
                return newSelection;
            }
        });
    };

    const handleDateChange = (itemId, itemType, date, index) => {
        setUpdateDates(prev => ({
            ...prev,
            [`${itemType}-${itemId}-${index}`]: date
        }));
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedItems([]);
        setUpdateDates({});
    };

    const handleRenewalSelected = () => {
        console.log('Renewal button clicked');
        console.log('Selected items:', selectedItems);
        
        if (selectedItems.length === 0) {
            alert('Please select at least one order to renew');
            return;
        }

        // For now, handle single renewal (can be extended for multiple)
        const orderToRenew = selectedItems[0];
        console.log('Order to renew:', orderToRenew);
        console.log('Available fields in order:', Object.keys(orderToRenew));
        console.log('ContractorId:', orderToRenew.ContractorId);
        console.log('CustomerId:', orderToRenew.CustomerId);
        console.log('Customer name fields:', {
            Customer: orderToRenew.Customer,
            customer: orderToRenew.customer,
            CustomerName: orderToRenew.CustomerName,
            CompanyName: orderToRenew.CompanyName
        });
        console.log('State fields:', {
            StateId: orderToRenew.StateId,
            stateId: orderToRenew.stateId,
            StateName: orderToRenew.StateName,
            stateName: orderToRenew.stateName,
            State: orderToRenew.State
        });
        
        // Create renewal data object to pass to Create page
        const renewalData = {
            isRenewal: true,
            originalOrderId: orderToRenew.Id || orderToRenew.id, // Store original order ID for updating renewal status
            originalOrder: orderToRenew,
            customerId: orderToRenew.CustomerId || orderToRenew.customerId,
            customerName: orderToRenew.Customer || orderToRenew.customer || orderToRenew.CustomerName || orderToRenew.CompanyName,
            subcontractId: orderToRenew.SubcontractId || orderToRenew.subcontractId || orderToRenew.SubcontractorId || orderToRenew.ContractorId,
            subcontractName: orderToRenew.SubcontractName || orderToRenew.subcontractName || orderToRenew.SubcontractorName || orderToRenew.ContractorName,
            stateId: orderToRenew.StateId || orderToRenew.stateId,
            stateName: orderToRenew.StateName || orderToRenew.stateName || orderToRenew.State,
            amcTypeId: orderToRenew.AMCTypeId || orderToRenew.amcTypeId || orderToRenew.DurationTypeId || 1, // Get AMC type from original order
            stampingFromDate: new Date().toISOString().split('T')[0], // Today's date
            hasStamping: true, // Renewal orders typically have stamping
            hasAMC: true // Most renewal orders have both stamping and AMC
        };

        console.log('Renewal data to store:', renewalData);
        console.log('Original order fields for debugging:', {
            AMCTypeId: orderToRenew.AMCTypeId,
            amcTypeId: orderToRenew.amcTypeId,
            DurationTypeId: orderToRenew.DurationTypeId,
            SubcontractId: orderToRenew.SubcontractId,
            SubcontractorId: orderToRenew.SubcontractorId,
            ContractorId: orderToRenew.ContractorId,
            allFields: Object.keys(orderToRenew)
        });

        // Store in localStorage to pass to Create page
        localStorage.setItem('renewalOrderData', JSON.stringify(renewalData));
        
        console.log('Navigating to PurchaseOrderCreate...');
        // Navigate to Create page
        window.location.href = '/PurchaseOrderCreate';
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            // Add rowIndex to each item for proper unique key generation
            const itemsWithIndex = modalData.map((item, index) => ({
                ...item,
                rowIndex: index
            }));
            setSelectedItems(itemsWithIndex);
            
            // Auto-fill current date for all selected items
            const currentDate = new Date().toISOString().split('T')[0];
            const newDates = {};
            itemsWithIndex.forEach((item, index) => {
                const dateKey = `${item.type}-${item.Id}-${index}`;
                newDates[dateKey] = currentDate;
            });
            setUpdateDates(newDates);
        } else {
            setSelectedItems([]);
            setUpdateDates({});
        }
    };

    // Helpers
    const normalizeDate = (candidate, createdDate) => {
        // candidate may be string or Date
        const cand = candidate ? new Date(candidate) : null;
        const created = createdDate ? new Date(createdDate) : null;

        // If candidate invalid, fallback to createdDate or today
        if (!cand || isNaN(cand.getTime())) {
            if (created && !isNaN(created.getTime())) return created.toISOString();
            return new Date().toISOString();
        }

        // If candidate is before createdDate, return createdDate
        if (created && !isNaN(created.getTime()) && cand < created) {
            return created.toISOString();
        }

        return cand.toISOString();
    };

    const prepareServicePayload = (item, modalUpdateDate, currentUserId) => {
        // Priority: Use the date picked from calendar (modalUpdateDate) if available
        const candidate = modalUpdateDate || item.ServiceUpdateDate || item.serviceUpdateDate || new Date().toISOString().split('T')[0];
        
        console.log('Service Payload - Item:', item, 'Selected Date:', modalUpdateDate, 'Final Date:', candidate);
        
        // Match the ServiceUpdate model structure exactly - include all required fields
        return {
            Id: item.Id ?? item.id ?? 0,
            CompanyId: item.CompanyId ?? item.companyId ?? companyId,
            PurchaseOrderId: item.PurchaseOrderId ?? item.PurchaseId ?? item.purchaseId ?? 0,
            CustomerId: item.CustomerId ?? item.customerId ?? 0,
            ServiceUpdateDate: candidate,
            IsService: true,
            Description: item.Description ?? "",  // Required field
            IsActive: item.IsActive ?? true,
            CreatedDate: item.CreatedDate ?? new Date().toISOString(),
            CreatedBy: item.CreatedBy ?? currentUserId,
            UpdatedDate: new Date().toISOString(),
            UpdatedBy: currentUserId,
            BillId: item.BillId ?? 0,
            BillNo: item.BillNo ?? "",  // Required field
            IsBilled: item.IsBilled ?? false,
            ReceiptId: item.ReceiptId ?? 0,
            ReceiptNo: item.ReceiptNo ?? "",  // Required field
            IsReceipt: item.IsReceipt ?? false,
            QuarterNo: item.QuarterNo ?? 0
        };
    };

    const prepareStampingPayload = (item, modalUpdateDate, currentUserId) => {
        // Priority: Use the date picked from calendar (modalUpdateDate) if available
        const candidate = modalUpdateDate || item.StampingUpdateDate || item.stampingUpdateDate || new Date().toISOString().split('T')[0];
        
        console.log('Stamping Payload - Item:', item, 'Selected Date:', modalUpdateDate, 'Final Date:', candidate);
        
        // Match the ServiceUpdate model structure exactly - include all required fields
        // Note: For stamping, we use ServiceUpdateDate field (not StampingUpdateDate) since the model only has ServiceUpdateDate
        return {
            Id: item.Id ?? item.id ?? 0,
            CompanyId: item.CompanyId ?? item.companyId ?? companyId,
            PurchaseId: item.PurchaseOrderId ?? item.PurchaseId ?? item.purchaseId ?? 0,
            CustomerId: item.CustomerId ?? item.customerId ?? 0,
            StampingUpdateDate: candidate,  // Using ServiceUpdateDate for stamping too
            IsStamping: true,  // False for stamping
            IsActive: item.IsActive ?? true,
            CreatedDate: item.CreatedDate ?? new Date().toISOString(),
            CreatedBy: item.CreatedBy ?? currentUserId,
            UpdatedDate: new Date().toISOString(),
            UpdatedBy: currentUserId,
            BillId: item.BillId ?? 0,
            BillNo: item.BillNo ?? "",  // Required field
            IsBilled: item.IsBilled ?? false,
            ReceiptId: item.ReceiptId ?? 0,
            ReceiptNo: item.ReceiptNo ?? "",  // Required field
            IsReceipt: item.IsReceipt ?? false,
            QuarterNo: item.QuarterNo ?? 0,
            Customer:null,
          
        };
    };

    // Updated handleUpdateSelected
    const handleUpdateSelected = async () => {
        if (!selectedItems || selectedItems.length === 0) {
            alert('Please select at least one item to update');
            return;
        }

        setIsUpdating(true);

        try {
            // Group items by whether they are service or stamping.
            // We check item.type (string) first, then fall back to boolean flags.
            const serviceItems = [];
            const stampingItems = [];

            // Get current user ID
            const currentUserId = userId ?? 1;

            selectedItems.forEach(item => {
                // Get the date from updateDates state for this specific item
                const dateKey = `${item.type}-${item.Id}-${item.rowIndex}`;
                const selectedDate = updateDates[dateKey];
                
                console.log(`Processing item ${item.Id}, dateKey: ${dateKey}, selectedDate: ${selectedDate}`);
                
                const itemType = (item.type || '').toString().toLowerCase();

                const isServiceByType = itemType === 'service';
                const isStampingByType = itemType === 'stamping';

                const isServiceFlag = !!item.isService;
                const isStampingFlag = !!item.isStamping;

                if (isServiceByType || isServiceFlag) {
                    serviceItems.push(prepareServicePayload(item, selectedDate, currentUserId));
                } else if (isStampingByType || isStampingFlag) {
                    stampingItems.push(prepareStampingPayload(item, selectedDate, currentUserId));
                } else {
                    // If neither flagged, try to infer from 'type' string; if not present, default to service
                    if (itemType) {
                        if (itemType.includes('service')) {
                            serviceItems.push(prepareServicePayload(item, selectedDate, currentUserId));
                        } else if (itemType.includes('stamp') || itemType.includes('stamping')) {
                            stampingItems.push(prepareStampingPayload(item, selectedDate, currentUserId));
                        } else {
                            // fallback: treat as service (change if you prefer)
                            serviceItems.push(prepareServicePayload(item, selectedDate, currentUserId));
                        }
                    } else {
                        // fallback default
                        serviceItems.push(prepareServicePayload(item, selectedDate, currentUserId));
                    }
                }
            });

            // Call APIs only for arrays that have items
            const results = { service: null, stamping: null };

            if (serviceItems.length > 0) {
                results.service = await updateServiceApi(serviceItems);
            }
            if (stampingItems.length > 0) {
                results.stamping = await updateStampingApi(stampingItems);
            }

            // Determine overall success
            const serviceOk = !results.service || results.service.success === true;
            const stampingOk = !results.stamping || results.stamping.success === true;

            if (serviceOk && stampingOk) {
                alert(`Successfully updated ${selectedItems.length} item(s)`);
                handleCloseModal();

                // Refresh dashboard
                const serviceData = await fetchServiceUpdates();
                const stampingData = await fetchStampingUpdates();
                const renewalData = await fetchRenewalOrders();
                await calculateDashboardStats(serviceData, stampingData, renewalData);
            } else {
                // Show more detailed message if available
                const errors = [];
                if (results.service && !results.service.success) errors.push('Service update failed');
                if (results.stamping && !results.stamping.success) errors.push('Stamping update failed');
                alert(`Update finished with errors: ${errors.join('; ')}`);
                console.error('Update responses', results);
            }
        } catch (error) {
            console.error('Update failed:', error);
            alert('Something went wrong while updating');
        } finally {
            setIsUpdating(false);
        }
    };

    const updateServiceApi = async (items) => {
        console.log('Calling Service Update API with items:', items);
        const response = await postData("AMCServiceApi/UpdateList", items, token);
        console.log('Service Update API Response:', response);
        return { success: response?.success === true };
    };

    const updateStampingApi = async (items) => {
        console.log('Calling Stamping Update API with items:', items);
        const response = await postData("StampApi/UpdateList", items, token);
        console.log('Stamping Update API Response:', response);
        return { success: response?.success === true };
    };

    const calculateDashboardStats = async (serviceData, stampingData, renewalData = []) => {
        let upcomingService = 0;
        let pendingService = 0;
        let completedService = 0;
        let upcomingStamping = 0;
        let pendingStamping = 0;
        let completedStamping = 0;
        let ordersForRenewal = 0;

        console.log('Service Data:', serviceData);
        console.log('Stamping Data:', stampingData);
        console.log('Renewal Data:', renewalData);

        // Process Service Data
        serviceData.forEach(item => {
            // Check both status and Status fields (case variations)
            const statusValue = item.status ?? item.Status;
            
            // Also check if already completed via IsService flag
            if (item.isService === true || item.IsService === true) {
                completedService++;
            } else if (statusValue === 3) {
                completedService++;
            } else if (statusValue === 2) {
                pendingService++;
            } else if (statusValue === 1) {
                upcomingService++;
            } else {
                // Default to upcoming if no clear status
                upcomingService++;
            }
        });

        // Process Stamping Data
        stampingData.forEach(item => {
            // Check both status and Status fields (case variations)
            const statusValue = item.status ?? item.Status;
            
            // Also check if already completed via IsStamping flag
            if (item.isStamping === true || item.IsStamping === true) {
                completedStamping++;
            } else if (statusValue === 3) {
                completedStamping++;
            } else if (statusValue === 2) {
                pendingStamping++;
            } else if (statusValue === 1) {
                upcomingStamping++;
            } else {
                // Fallback logic for items without clear status
                // Check if it's in current month for pending
                const currentMonth = new Date().getMonth();
                const currentYear = new Date().getFullYear();

                let isCurrentMonth = false;
                if (item.StampingToDate) {
                    const date = new Date(item.StampingToDate);
                    isCurrentMonth = date.getMonth() === currentMonth && date.getFullYear() === currentYear;
                }

                if (isCurrentMonth) {
                    pendingStamping++;
                } else {
                    upcomingStamping++;
                }
            }
        });

        // Process Renewal Data
        if (renewalData && Array.isArray(renewalData)) {
            ordersForRenewal = renewalData.length;
        }

        console.log('Dashboard Stats:', { 
            upcomingService, pendingService, completedService,
            upcomingStamping, pendingStamping, completedStamping,
            ordersForRenewal
        });

        setDashboardStats({
            upcomingService,
            pendingService,
            completedService,
            upcomingStamping,
            pendingStamping,
            completedStamping,
            ordersForRenewal
        });
    };

    const fetchServiceReminders = async () => {
        // Create reminders based on counts from API
        const reminders = [];

        console.log('Service Update Count:', serviceUpdateCount);
        console.log('Stamping Update Count:', stampingUpdateCount);

        // Always show both cards, even if count is 0
        reminders.push({
            id: 1,
            type: "Service Updates Pending",
            count: serviceUpdateCount || 0
        });

        reminders.push({
            id: 2,
            type: "Stamping Updates Pending",
            count: stampingUpdateCount || 0
        });

        console.log('Service Reminders:', reminders);
        setServiceReminders(reminders);
    };

    const calculateUpcomingRenewals = (serviceData, stampingData) => {
        const today = new Date();
        const urgent = [];      // 7 days
        const warning = [];     // 15 days
        const upcoming = [];    // 30 days

        // Combine all data
        const allData = [
            ...serviceData.map(item => ({ ...item, type: 'Service' })),
            ...stampingData.map(item => ({ ...item, type: 'Stamping' }))
        ];

        allData.forEach(item => {
            let expiryDate = null;

            // Get expiry date based on type
            if (item.type === 'Service' && item.ServiceToDate) {
                expiryDate = new Date(item.ServiceToDate);
            } else if (item.type === 'Stamping' && item.StampingToDate) {
                expiryDate = new Date(item.StampingToDate);
            }

            if (expiryDate && expiryDate > today) {
                const daysUntilExpiry = Math.ceil((expiryDate - today) / (1000 * 60 * 60 * 24));

                const renewalItem = {
                    ...item,
                    daysUntilExpiry,
                    expiryDate: expiryDate.toLocaleDateString('en-GB')
                };

                if (daysUntilExpiry <= 7) {
                    urgent.push(renewalItem);
                } else if (daysUntilExpiry <= 15) {
                    warning.push(renewalItem);
                } else if (daysUntilExpiry <= 30) {
                    upcoming.push(renewalItem);
                }
            }
        });

        setUpcomingRenewals({ urgent, warning, upcoming });
    };

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setToDate(getFormattedCurrentDate());
        fetchtableData();
        fetchTableData();

        // Fetch data and calculate stats
        const loadDashboardData = async () => {
            const serviceData = await fetchServiceUpdates();
            const stampingData = await fetchStampingUpdates();
            const renewalData = await fetchRenewalOrders();
            await calculateDashboardStats(serviceData, stampingData, renewalData);
            calculateUpcomingRenewals(serviceData, stampingData);
        };

        loadDashboardData();
    }, [isAuthenticated, token, logout]);

    // Update reminders whenever counts change
    useEffect(() => {
        fetchServiceReminders();
    }, [serviceUpdateCount, stampingUpdateCount]);

    const hasReadMasterPermission = permissions.includes('Read Master');
    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasReadTransactionPermission = permissions.includes('Read Transaction');
    const hasCreateAccountsPermission = permissions.includes('Create Accounts');
    const hasReadAccountsPermission = permissions.includes('Read Accounts');
    const hasReadAdministrationPermission = permissions.includes('Read Administration');
    const hasReadReadReportsPermission = permissions.includes('Read Reports');

    const features = [
        {
            title: "Purchase Order",
            icon: <Receipt style={{ color: '#2563eb', fontSize: '24px' }} />,
            link: "/PurchaseOrderIndex",
            description: "Manage orders & services"
        },
        {
            title: "Subcontractor Entry",
            icon: <Assessment style={{ color: '#7c3aed', fontSize: '24px' }} />,
            link: "/SubContractIndex",
            description: "Manage subcontractors"
        },
    ];

    const [activeGroup, setActiveGroup] = useState(null); // null or group name

    const toggleGroup = (group) => {
        setActiveGroup(activeGroup === group ? null : group);
    };

    const groupColors = {
        Accounts: { main: "rgba(156,39,176,0.15)", hover: "rgba(156,39,176,0.25)" },
        Sales: { main: "rgba(76,175,80,0.15)", hover: "rgba(76,175,80,0.25)" },
        Purchase: { main: "rgba(255,165,0,0.15)", hover: "rgba(255,165,0,0.25)" },
    };

    const toggleFavorite = async (report) => {
        try {
            const existingItems = await fetchData('PinnedItemsApi', `/${companyId}/${userId}`, token);

            if (
                existingItems.response_data?.some(
                    (item) => item.ReportDescription === report.name
                )
            ) {
                alert('This report is already in your favorites.');
                return;
            }

            const pinned = {
                ReportDescription: report.name,
                ReportId: report.id,
                IsLocked: true,
                CompanyId: companyId,
                UserId: userId,
            };

            const response = await postData('PinnedItemsApi', pinned, token);
            fetchtableData(); // Refresh the pinned items
            alert('Favorite added successfully!');
            if (response.status === 200) {
                const updatedFavorites = favorites.includes(report.id)
                    ? favorites.filter((favId) => favId !== report.id)
                    : [...favorites, report.id];
                setFavorites(updatedFavorites);

            } else {
                console.error('Error adding favorite:', response.data?.message || 'Unknown error');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred. Please try again.');
        }
    };

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const fetchtableData = async () => {
        fetchData('PinnedItemsApi', `/${companyId}/${userId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);

                }
            })
            .catch((error) => {
                console.error('Error fetching Supplier Details:', error);
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleFavoriteRemove = async (id) => {
        try {
            await deleteData('PinnedItemsApi', `${id}`, token); // Perform the delete operation
            fetchtableData(); // Refresh the table data
        } catch (error) {
            console.error('Error deleting record:', error);
        }
    };

    const [currentMonth, setCurrentMonth] = useState(new Date());

    // Helper functions
    const prevMonth = () => {
        const prev = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1);
        setCurrentMonth(prev);
    };

    const nextMonth = () => {
        const next = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1);
        setCurrentMonth(next);
    };

    const getDaysInMonth = (month, year) => {
        const date = new Date(year, month, 1);
        const days = [];
        const firstDay = new Date(year, month, 1).getDay(); // Day of week (0-6)
        const lastDate = new Date(year, month + 1, 0).getDate(); // Last date of month

        // Add blank days for first week
        for (let i = 0; i < firstDay; i++) {
            days.push(null);
        }

        // Add all dates of the month
        for (let d = 1; d <= lastDate; d++) {
            days.push(new Date(year, month, d));
        }

        return days;
    };

    const days = getDaysInMonth(currentMonth.getMonth(), currentMonth.getFullYear());

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const [selectedDate, setSelectedDate] = React.useState(null); // store the selected date

    // Update your dayStyle function
    const dayStyle = (day) => {
        const isToday = day && day.toDateString() === new Date().toDateString();
        const isSelected = day && selectedDate && day.toDateString() === selectedDate.toDateString();

        return {
            width: "30px",
            height: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "2px",
            borderRadius: "4px",
            backgroundColor: isSelected
                ? "yellow" // highlight selected date
                : isToday
                    ? "#1A1A1D" // today
                    : day
                        ? "#f0f0f0" // normal day
                        : "transparent", // empty cell
            color: isSelected
                ? "#1A1A1D"
                : isToday
                    ? "#fff"
                    : "#1A1A1D",
            fontSize: "12px",
            cursor: day ? "pointer" : "default",
        };
    };

    // Selected Day Datalog
    const [open, setOpen] = useState(false);
    // Inside your component, after fetching data
    const [dailyStatement, setDailyStatement] = useState(null);

    // When fetching
    const handleDateClick = async (day) => {
        setSelectedDate(day);
        setOpen(true);
        // ✅ Format as local date (no UTC conversion)
        const formattedDate = `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`;
        try {
            setDataItem([]); // optional, if you have a table
            const response = await fetchData(
                'ReportApi',
                `/DailyStatement/${formattedDate}/${formattedDate}/${companyId}`,
                token
            );

            if (response.responseCode === '1111') {
                const ds = response.response_data; // assuming API returns object like DailyStatement
                setDailyStatement(ds);
            }
        } catch (error) {
            console.error('Error fetching Daily Statement Details:', error);
        }
    };

    // Group your metrics
    const quantityMetrics = dailyStatement
        ? [
            { label: "Sale", value: dailyStatement.SaleQuantity },
            { label: "Purchase", value: dailyStatement.PurchaseQuantity },
        ]
        : [];

    const salesMetrics = dailyStatement
        ? [
            { label: "Cash", value: dailyStatement.SaleCashAmount },
            { label: "Card", value: dailyStatement.SaleCardAmount },
            { label: "UPI", value: dailyStatement.SaleUpiAmount },
            { label: "Credit", value: dailyStatement.SaleCreditAmount },
        ]
        : [];

    const purchaseMetrics = dailyStatement
        ? [
            { label: "Cash", value: dailyStatement.PurchaseCashAmount },
            { label: "Credit", value: dailyStatement.PurchaseCreditAmount },
        ]
        : [];

    const receiptsMetrics = dailyStatement
        ? [
            { label: "Payment", value: dailyStatement.PaymentAmount },
            { label: "Receipt", value: dailyStatement.ReceiptAmount },
            { label: "Income", value: dailyStatement.IncomeAmount },
            { label: "Expense", value: dailyStatement.ExpenseAmount },
        ]
        : [];

    const fetchTableData = async (date) => {
        if (!date) return;
        setDataItem([]);
        try {
            const formattedDate = date.toISOString().split('T')[0]; // YYYY-MM-DD
            const response = await fetchData(
                'ReportApi',
                `/DailyStatement/${formattedDate}/${formattedDate}/${companyId}`,
                token
            );

            if (response.responseCode === '1111') {
                setDataItem(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Daily Statement Details:', error);
        }
    };

    return (
        <div className="home-container" style={{marginTop:'-20px'}}>
            {/* Dashboard Header */}
            <div className="dashboard-header">
                <div className="dashboard-header-content">
                    <div className="dashboard-greeting">
                        <div className="greeting-icon">{greeting.icon}</div>
                        <div className="greeting-text">
                            <span className="greeting-time">{greeting.text}</span>
                            <h1 className="dashboard-title">Welcome back, {username || 'User'} !</h1>
                            <p className="dashboard-subtitle">ESKAY</p>
                        </div>
                    </div>
                    <div className="dashboard-time">
                        <div className="current-time">
                            {new Date().toLocaleTimeString('en-US', { 
                                hour: '2-digit', 
                                minute: '2-digit',
                                hour12: true 
                            })}
                        </div>
                        <div className="current-date">
                            {new Date().toLocaleDateString('en-US', { 
                                weekday: 'long', 
                                month: 'short', 
                                day: 'numeric' 
                            })}
                        </div>
                    </div>
                </div>
            </div>

            {/* Dashboard Status Cards */}
            <div className="dashboard-stats-grid" style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', 
                gap: '16px', 
                marginBottom: '30px' 
            }}>
                {/* Upcoming Cards */}
                <div className="stat-card stat-card-upcoming" onClick={() => handleCardClick('upcomingService')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">
                        <NotificationsActive style={{ fontSize: 20, color: '#ffffff' }} />
                    </div>
                    <div className="stat-content">
                        <div className="stat-label">Upcoming Service</div>
                        <div className="stat-value">{dashboardStats.upcomingService}</div>
                    </div>
                </div>

                <div className="stat-card stat-card-upcoming" onClick={() => handleCardClick('upcomingStamping')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">
                        <NotificationsActive style={{ fontSize: 20, color: '#ffffff' }} />
                    </div>
                    <div className="stat-content">
                        <div className="stat-label">Upcoming Stamping</div>
                        <div className="stat-value">{dashboardStats.upcomingStamping}</div>
                    </div>
                </div>

                {/* Pending Cards */}
                <div className="stat-card stat-card-pending" onClick={() => handleCardClick('pendingService')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">
                        <Receipt style={{ fontSize: 20, color: '#ffffff' }} />
                    </div>
                    <div className="stat-content">
                        <div className="stat-label">Pending Service</div>
                        <div className="stat-value">{dashboardStats.pendingService}</div>
                    </div>
                </div>

                <div className="stat-card stat-card-pending" onClick={() => handleCardClick('pendingStamping')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">
                        <Receipt style={{ fontSize: 20, color: '#ffffff' }} />
                    </div>
                    <div className="stat-content">
                        <div className="stat-label">Pending Stamping</div>
                        <div className="stat-value">{dashboardStats.pendingStamping}</div>
                    </div>
                </div>

                {/* Completed Cards */}
                <div className="stat-card stat-card-completed" onClick={() => handleCardClick('completedService')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">
                        <Assessment style={{ fontSize: 20, color: '#ffffff' }} />
                    </div>
                    <div className="stat-content">
                        <div className="stat-label">Completed Service</div>
                        <div className="stat-value">{dashboardStats.completedService}</div>
                    </div>
                </div>

                <div className="stat-card stat-card-completed" onClick={() => handleCardClick('completedStamping')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">
                        <Assessment style={{ fontSize: 20, color: '#ffffff' }} />
                    </div>
                    <div className="stat-content">
                        <div className="stat-label">Completed Stamping</div>
                        <div className="stat-value">{dashboardStats.completedStamping}</div>
                    </div>
                </div>

                {/* Renewal Orders Card */}
                <div className="stat-card stat-card-renewal" onClick={() => handleCardClick('renewal')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">
                        <ArrowCircleRightIcon style={{ fontSize: 20, color: '#ffffff' }} />
                    </div>
                    <div className="stat-content">
                        <div className="stat-label">Orders for Renewal</div>
                        <div className="stat-value">{dashboardStats.ordersForRenewal}</div>
                    </div>
                </div>
            </div>

            {/* Upcoming Renewals Alert Section */}
            {(upcomingRenewals.urgent.length > 0 || upcomingRenewals.warning.length > 0 || upcomingRenewals.upcoming.length > 0) && (
                <div className="renewals-alert-section">
                    <div className="renewals-header">
                        <div className="renewals-icon">
                            <NotificationsActive style={{ fontSize: 20, color: '#ffffff' }} />
                        </div>
                        <div>
                            <h2 className="renewals-title">Upcoming Renewals</h2>
                            <p className="renewals-subtitle">Customers requiring attention in the next 30 days</p>
                        </div>
                    </div>

                    <div className="renewals-grid">
                        {/* Urgent - 7 Days */}
                        {upcomingRenewals.urgent.length > 0 && (
                            <div className="renewal-category urgent">
                                <div className="category-header">
                                    <span className="category-icon" style={{ color: '#ec0404' }}>●</span>
                                    <div>
                                        <h3 className="category-title">Urgent (≤7 Days)</h3>
                                        <p className="category-count">{upcomingRenewals.urgent.length} customer{upcomingRenewals.urgent.length > 1 ? 's' : ''}</p>
                                    </div>
                                </div>
                                <div className="renewal-list">
                                    {upcomingRenewals.urgent.slice(0, 3).map((item, index) => (
                                        <div key={index} className="renewal-item">
                                            <div className="renewal-info">
                                                <span className="renewal-customer">{item.Customer || item.customer || item.CustomerName || 'N/A'}</span>
                                                <span className="renewal-type-badge urgent-badge">{item.type}</span>
                                            </div>
                                            <div className="renewal-details">
                                                <span className="renewal-days">{item.daysUntilExpiry} day{item.daysUntilExpiry > 1 ? 's' : ''} left</span>
                                                <span className="renewal-date">{item.expiryDate}</span>
                                            </div>
                                        </div>
                                    ))}
                                    {upcomingRenewals.urgent.length > 3 && (
                                        <div className="renewal-more">+{upcomingRenewals.urgent.length - 3} more</div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Warning - 15 Days */}
                        {upcomingRenewals.warning.length > 0 && (
                            <div className="renewal-category warning">
                                <div className="category-header">
                                    <span className="category-icon" style={{ color: '#f5f10bff' }}>●</span>
                                    <div>
                                        <h3 className="category-title">Warning (≤15 Days)</h3>
                                        <p className="category-count">{upcomingRenewals.warning.length} customer{upcomingRenewals.warning.length > 1 ? 's' : ''}</p>
                                    </div>
                                </div>
                                <div className="renewal-list">
                                    {upcomingRenewals.warning.slice(0, 3).map((item, index) => (
                                        <div key={index} className="renewal-item">
                                            <div className="renewal-info">
                                                <span className="renewal-customer">{item.Customer || item.customer || item.CustomerName || 'N/A'}</span>
                                                <span className="renewal-type-badge warning-badge">{item.type}</span>
                                            </div>
                                            <div className="renewal-details">
                                                <span className="renewal-days">{item.daysUntilExpiry} days left</span>
                                                <span className="renewal-date">{item.expiryDate}</span>
                                            </div>
                                        </div>
                                    ))}
                                    {upcomingRenewals.warning.length > 3 && (
                                        <div className="renewal-more">+{upcomingRenewals.warning.length - 3} more</div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Upcoming - 30 Days */}
                        {upcomingRenewals.upcoming.length > 0 && (
                            <div className="renewal-category upcoming">
                                <div className="category-header">
                                    <span className="category-icon" style={{ color: '#10b981' }}>●</span>
                                    <div>
                                        <h3 className="category-title">Upcoming (≤30 Days)</h3>
                                        <p className="category-count">{upcomingRenewals.upcoming.length} customer{upcomingRenewals.upcoming.length > 1 ? 's' : ''}</p>
                                    </div>
                                </div>
                                <div className="renewal-list">
                                    {upcomingRenewals.upcoming.slice(0, 3).map((item, index) => (
                                        <div key={index} className="renewal-item">
                                            <div className="renewal-info">
                                                <span className="renewal-customer">{item.Customer || item.customer || item.CustomerName || 'N/A'}</span>
                                                <span className="renewal-type-badge upcoming-badge">{item.type}</span>
                                            </div>
                                            <div className="renewal-details">
                                                <span className="renewal-days">{item.daysUntilExpiry} days left</span>
                                                <span className="renewal-date">{item.expiryDate}</span>
                                            </div>
                                        </div>
                                    ))}
                                    {upcomingRenewals.upcoming.length > 3 && (
                                        <div className="renewal-more">+{upcomingRenewals.upcoming.length - 3} more</div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Details Modal */}
            <Modal open={modalOpen} onClose={handleCloseModal}>
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '90%',
                    maxWidth: '800px',
                    maxHeight: '80vh',
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    border: `3px solid ${
                        modalType === 'upcoming' ? '#fbbf24' : 
                        modalType === 'pending' ? '#ec0404' : 
                        modalType === 'completed' ? '#12d643ff' : 
                        modalType === 'renewal' ? '#3b82f6' : '#6b7280'
                    }`,
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                    outline: 'none',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <div style={{
                        padding: '12px 16px',
                        borderBottom: `2px solid ${
                            modalType === 'upcoming' ? '#fbbf24' : 
                            modalType === 'pending' ? '#ec0404' : 
                            modalType === 'completed' ? '#12d643ff' : 
                            modalType === 'renewal' ? '#3b82f6' : '#6b7280'
                        }`,
                        backgroundColor: 'white',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <div>
                            <h2 style={{
                                margin: 0,
                                fontSize: '18px',
                                fontWeight: '700',
                                color: modalType === 'upcoming' ? '#d97706' : 
                                       modalType === 'pending' ? '#ec0404' : 
                                       modalType === 'completed' ? '#12d643ff' : 
                                       modalType === 'renewal' ? '#3b82f6' : '#374151'
                            }}>{modalTitle}</h2>
                            
                            
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {modalData.length > 0 && modalType === 'renewal' && (
                                <Button
                                    variant="contained"
                                    onClick={handleRenewalSelected}
                                    disabled={selectedItems.length === 0}
                                    style={{
                                        background: selectedItems.length > 0 ? '#3b82f6' : '#d1d5db',
                                        color: 'white',
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        padding: '6px 16px',
                                        borderRadius: '6px',
                                        fontSize: '13px',
                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                                        cursor: selectedItems.length === 0 ? 'not-allowed' : 'pointer',
                                        minWidth: 'auto'
                                    }}
                                >
                                    Create Renewal ({selectedItems.length})
                                </Button>
                            )}
                            {modalData.length > 0 && modalType !== 'completed' && modalType !== 'renewal' && (
                                <Button
                                    variant="contained"
                                    onClick={handleUpdateSelected}
                                    disabled={isUpdating || selectedItems.length === 0}
                                    startIcon={isUpdating ? <CircularProgress size={14} color="inherit" /> : null}
                                    style={{
                                        background: selectedItems.length > 0 ? 
                                            (modalType === 'upcoming' ? '#f59e0b' : 
                                             modalType === 'pending' ? '#ec0404' : 
                                             modalType === 'renewal' ? '#3b82f6' : '#12d643ff') : '#d1d5db',
                                        color: 'white',
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        padding: '6px 16px',
                                        borderRadius: '6px',
                                        fontSize: '13px',
                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                                        cursor: isUpdating || selectedItems.length === 0 ? 'not-allowed' : 'pointer',
                                        minWidth: 'auto'
                                    }}
                                >
                                    {isUpdating ? 'Updating...' : `Update (${selectedItems.length})`}
                                </Button>
                            )}
                            <button 
                                onClick={handleCloseModal}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                    color: '#6b7280',
                                    padding: '4px',
                                    borderRadius: '4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >✕</button>
                        </div>
                    </div>



                    <div style={{
                        flex: 1,
                        overflow: 'auto',
                        backgroundColor: 'white',
                        padding: '8px'
                    }}>
                        {modalData.length > 0 ? (
                            <TableContainer component={Paper} style={{ 
                                boxShadow: 'none', 
                                borderRadius: 0,
                                backgroundColor: 'white'
                            }}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow style={{
                                            background: modalType === 'upcoming' ? 'linear-gradient(135deg, #d97706 0%, #b45309 100%)' : 
                                                       modalType === 'pending' ? 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)' : 
                                                       modalType === 'completed' ? 'linear-gradient(135deg, #059669 0%, #047857 100%)' : 
                                                       modalType === 'renewal' ? 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)' : '#f8fafc'
                                        }}>
                                            {modalType !== 'completed' && (
                                                <TableCell padding="checkbox" style={{ 
                                                    width: 50,
                                                    fontWeight: 'bold',
                                                    fontSize: '13px',
                                                    color: modalType === 'upcoming' ? '#ffffff' : 
                                                           modalType === 'pending' ? '#ffffff' : 
                                                           modalType === 'completed' ? '#ffffff' : 
                                                           modalType === 'renewal' ? '#ffffff' : '#475569'
                                                }}>
                                                    <input
                                                        type="checkbox"
                                                        onChange={handleSelectAll}
                                                        checked={selectedItems.length === modalData.length}
                                                        style={{ accentColor: modalType === 'upcoming' ? '#f59e0b' : 
                                                                              modalType === 'pending' ? '#ec0404' : '#10b981' }}
                                                    />
                                                </TableCell>
                                            )}
                                            <TableCell style={{ 
                                                width: 100,
                                                fontWeight: 'bold',
                                                fontSize: '13px',
                                                color: modalType === 'upcoming' ? '#ffffff' : 
                                                       modalType === 'pending' ? '#ffffff' : 
                                                       modalType === 'completed' ? '#ffffff' : 
                                                       modalType === 'renewal' ? '#ffffff' : '#475569'
                                            }}>Type</TableCell>
                                            <TableCell style={{ 
                                                width: 100,
                                                fontWeight: 'bold',
                                                fontSize: '13px',
                                                color: modalType === 'upcoming' ? '#ffffff' : 
                                                       modalType === 'pending' ? '#ffffff' : 
                                                       modalType === 'completed' ? '#ffffff' : 
                                                       modalType === 'renewal' ? '#ffffff' : '#475569'
                                            }}>Order No</TableCell>
                                            <TableCell style={{
                                                fontWeight: 'bold',
                                                fontSize: '13px',
                                                color: modalType === 'upcoming' ? '#ffffff' : 
                                                       modalType === 'pending' ? '#ffffff' : 
                                                       modalType === 'completed' ? '#ffffff' : 
                                                       modalType === 'renewal' ? '#ffffff' : '#475569'
                                            }}>Customer</TableCell>
                                            <TableCell style={{ 
                                                width: 150,
                                                fontWeight: 'bold',
                                                fontSize: '13px',
                                                color: modalType === 'upcoming' ? '#ffffff' : 
                                                       modalType === 'pending' ? '#ffffff' : 
                                                       modalType === 'completed' ? '#ffffff' : 
                                                       modalType === 'renewal' ? '#ffffff' : '#475569'
                                            }}>
                                                {modalType === 'completed' ? 'Completed Date' : 
                                                 modalType === 'renewal' ? 'Expiry Date' : 'Update Date'}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {modalData.map((item, index) => {
                                            const itemWithIndex = { ...item, rowIndex: index };
                                            const isSelected = selectedItems.find(i => getUniqueKey(i) === getUniqueKey(itemWithIndex));
                                            return (
                                                <TableRow
                                                    key={index}
                                                    hover
                                                    className={isSelected ? 'row-selected' : ''}
                                                    data-selected={isSelected ? 'true' : 'false'}
                                                >
                                                    {modalType !== 'completed' && (
                                                        <TableCell padding="checkbox">
                                                            <input
                                                                type="checkbox"
                                                                checked={!!isSelected}
                                                                onChange={(e) => {
                                                                    e.stopPropagation();
                                                                    handleCheckboxChange(itemWithIndex);
                                                                }}
                                                                className="custom-checkbox"
                                                            />
                                                        </TableCell>
                                                    )}
                                                    <TableCell>
                                                        <span className={`type-badge ${
                                                            itemWithIndex.type === 'Service' ? 'type-badge-service' : 
                                                            itemWithIndex.type === 'Stamping' ? 'type-badge-stamping' : 
                                                            itemWithIndex.type === 'Renewal' ? 'type-badge-renewal' : 'type-badge-service'
                                                        }`}>
                                                            {itemWithIndex.type}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: 600 }}>
                                                        {(() => {
                                                            const orderNo = itemWithIndex.PoNumber || itemWithIndex.poNumber || 
                                                                           itemWithIndex.PONumber || itemWithIndex.PurchaseOrderNo || 
                                                                           itemWithIndex.OrderNo || itemWithIndex.orderNo || 
                                                                           itemWithIndex.PurchaseOrderNumber || itemWithIndex.PONo ||
                                                                           itemWithIndex.Id || itemWithIndex.PurchaseOrderId;
                                                            
                                                            // Debug log for renewal items
                                                            if (itemWithIndex.type === 'Renewal' && !orderNo) {
                                                                console.log('Renewal item missing order number:', itemWithIndex);
                                                            }
                                                            
                                                            return orderNo || '—';
                                                        })()}
                                                    </TableCell>
                                                    <TableCell>
                                                        {itemWithIndex.Customer || itemWithIndex.customer || 
                                                         itemWithIndex.CustomerName || itemWithIndex.customerName || 
                                                         itemWithIndex.CompanyName || itemWithIndex.companyName || '—'}
                                                    </TableCell>
                                                    <TableCell>
                                                        {modalType === 'completed' ? (
                                                            <span style={{ 
                                                                fontSize: '13px', 
                                                                color: '#34d399',
                                                                fontWeight: 600,
                                                                padding: '6px 14px',
                                                                background: 'rgba(16,185,129,0.15)',
                                                                borderRadius: '6px',
                                                                display: 'inline-block'
                                                            }}>
                                                                {(() => {
                                                                    const dateToShow = itemWithIndex.type === 'Service' 
                                                                        ? (itemWithIndex.serviceUpdateDate || itemWithIndex.UpdatedDate)
                                                                        : (itemWithIndex.stampingUpdateDate || itemWithIndex.UpdatedDate);
                                                                    
                                                                    return dateToShow 
                                                                        ? new Date(dateToShow).toLocaleDateString('en-GB')
                                                                        : 'N/A';
                                                                })()}
                                                            </span>
                                                        ) : modalType === 'renewal' ? (
                                                            <span style={{ 
                                                                fontSize: '13px', 
                                                                color: '#3b82f6',
                                                                fontWeight: 600,
                                                                padding: '6px 14px',
                                                                background: 'rgba(59,130,246,0.15)',
                                                                borderRadius: '6px',
                                                                display: 'inline-block'
                                                            }}>
                                                                {(() => {
                                                                    // For renewal orders, show the PO date or other date fields
                                                                    const expiryDate = itemWithIndex.PODate || itemWithIndex.poDate || 
                                                                                      itemWithIndex.ServiceToDate || itemWithIndex.StampingToDate || 
                                                                                      itemWithIndex.ExpiryDate || itemWithIndex.ToDate || 
                                                                                      itemWithIndex.EndDate || itemWithIndex.ValidTill;
                                                                    return expiryDate 
                                                                        ? new Date(expiryDate).toLocaleDateString('en-GB')
                                                                        : 'N/A';
                                                                })()}
                                                            </span>
                                                        ) : (
                                                            <input
                                                                type="date"
                                                                value={updateDates[`${itemWithIndex.type}-${itemWithIndex.Id}-${index}`] || ''}
                                                                onChange={(e) => handleDateChange(itemWithIndex.Id, itemWithIndex.type, e.target.value, index)}
                                                                onClick={(e) => e.stopPropagation()}
                                                                className="date-picker-input"
                                                            />
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <div className="modal-empty">
                                <Inventory style={{ fontSize: 48, color: '#cbd5e1', marginBottom: 12 }} />
                                <p>No data available</p>
                            </div>
                        )}
                    </div>
                </div>
            </Modal>


            {/* Quick Actions Section */}
            <div className="quick-actions-section">
                <h2 className="section-header">Quick Actions</h2>
                <div className="quick-actions-grid">
                    {features.map((feature, index) => {
                        const isAllowed =
                            feature.title === "Payment" || feature.title === "Receipt"
                                ? hasCreateAccountsPermission
                                : feature.title === "Reports"
                                    ? hasReadReadReportsPermission
                                    : hasCreateTransactionPermission;

                        return (
                            <Link
                                key={index}
                                to={feature.link}
                                className="action-card animate-fade-in-up"
                                style={{ 
                                    pointerEvents: isAllowed ? 'auto' : 'none', 
                                    opacity: isAllowed ? 1 : 0.5,
                                    animationDelay: `${0.1 * (index + 1)}s`
                                }}
                            >
                                <div className="action-card-content">
                                    {feature.badge > 0 && (
                                        <span className="action-badge">{feature.badge}</span>
                                    )}
                                    <div className="action-icon-wrapper">
                                        {feature.icon}
                                    </div>
                                    <div className="action-details">
                                        <h3 className="action-title">{feature.title}</h3>
                                        <p className="action-subtitle">{feature.description || 'Click to manage'}</p>
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>



            <Grid container spacing={2} style={{ display: 'none' }}>
                <Grid item xs={12} md={2}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <Card
                            style={{
                                padding: "7px",
                                borderRadius: "12px",
                                //backgroundColor: "#1E1E1E",
                                backgroundColor: "#0D1B2A",
                                color: "#F5F5F5",
                                maxWidth: "250px",
                                margin: "auto",
                                boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
                            }}
                        >
                            <CardContent>
                                {/* Header with month navigation */}
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                                    <IconButton size="small" onClick={prevMonth} style={{ color: "#F5F5F5" }}>
                                        <ArrowBackIosIcon fontSize="small" />
                                    </IconButton>
                                    <Typography variant="subtitle1" style={{ fontFamily: "monospace", fontWeight: "bold" }}>
                                        {monthNames[currentMonth.getMonth()]} {currentMonth.getFullYear()}
                                    </Typography>
                                    <IconButton size="small" onClick={nextMonth} style={{ color: "#F5F5F5" }}>
                                        <ArrowForwardIosIcon fontSize="small" />
                                    </IconButton>
                                </div>

                                {/* Days of the week */}
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(7, 1fr)",
                                    gap: "3px",
                                    textAlign: "center",
                                    marginBottom: "8px",
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                    color: "#A0C1E8"
                                }}>
                                    {["S", "M", "T", "W", "T", "F", "S"].map((d, index) => (
                                        <div key={index}>{d}</div>
                                    ))}
                                </div>

                                {/* Calendar days */}
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(7, 1fr)",
                                    gap: "6px",
                                    justifyItems: "center",
                                }}>

                                    {days.map((day, index) => {
                                        if (!day) return <div key={index} />;

                                        const isToday = day.toDateString() === new Date().toDateString();
                                        const isSelected = selectedDate && day.toDateString() === selectedDate.toDateString();

                                        const handleClick = () => {
                                            handleDateClick(day);
                                            fetchTableData(day); // Pass the clicked day explicitly
                                        }

                                        return (
                                            <div
                                                key={index}
                                                onClick={handleClick}
                                                style={{
                                                    width: "25px",
                                                    height: "28px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "8px",
                                                    fontSize: "11.5px",
                                                    backgroundColor: isSelected ? "#FFD166" : isToday ? "#EF476F" : "#102A43",
                                                    color: isSelected ? "#1A1A1D" : isToday ? "#FFF" : "#E0E6ED",
                                                    fontWeight: isToday || isSelected ? "bold" : "normal",
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease-in-out"
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (!isToday && !isSelected) e.currentTarget.style.backgroundColor = "#1B3B6F";
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (!isToday && !isSelected) e.currentTarget.style.backgroundColor = "#102A43";
                                                }}
                                            >
                                                {day.getDate()}
                                            </div>
                                        );
                                    })}

                                </div>

                            </CardContent>
                        </Card>


                        {/* Feature Cards */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {features.map((feature, index) => {
                                const isAllowed =
                                    feature.title === "Payment" || feature.title === "Receipt"
                                        ? hasCreateAccountsPermission
                                        : feature.title === "Reports"
                                            ? hasReadReadReportsPermission
                                            : hasCreateTransactionPermission;

                                return (

                                    <Card
                                        key={index}
                                        className={`transition-transform duration-300 ease-in-out transform ${isAllowed ? "hover:-translate-y-1 hover:shadow-2xl" : "opacity-50 cursor-not-allowed"
                                            }`}
                                        style={{
                                            padding: "7px",
                                            borderRadius: "12px",
                                            backgroundColor: "#0D1B2A",
                                            color: "#F5F5F5",
                                            maxWidth: "250px",
                                            margin: "auto",
                                            boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
                                        }}
                                    >
                                        <CardContent
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "flex-start",
                                                height: "30px",
                                                padding: "8px 10px",
                                                gap: "4px",
                                                width: "300px",
                                            }}
                                        >
                                            <Link
                                                to={feature.link}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    textDecoration: "none",
                                                    color: "inherit",
                                                    width: "100%",
                                                    fontFamily: "monospace",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "18px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        color: 'whitesmoke'
                                                    }}
                                                >
                                                    {feature.icon}
                                                </span>
                                                <Typography
                                                    variant="subtitle1"
                                                    style={{
                                                        marginLeft: "10px",
                                                        fontWeight: 500,
                                                        textTransform: "uppercase",
                                                        fontSize: "11px",
                                                    }}
                                                >
                                                    {feature.title}
                                                </Typography>
                                            </Link>
                                        </CardContent>
                                    </Card>

                                );
                            })}
                        </div>




                    </div>
                </Grid>

                {/* Middle - Charts */}
                <Grid item xs={12} md={7} style={{ marginTop: '-50px' }}>
                    {/* <CategorySalesChart />
                    <SalesPaymentStatusChart /> */}
                </Grid>

                <Grid item xs={12} md={3} style={{ marginTop: '-50px' }}>
                    <h6
                        style={{
                            fontFamily: 'Verdana, sans-serif',
                            fontSize: '14px',
                            textTransform: 'uppercase',
                            fontWeight: '900',
                            color: '#4b3f72',
                            textAlign: 'center',
                            marginBottom: '16px',
                            letterSpacing: '1px',
                            position: 'relative',
                        }}
                    >
                        REPORT LIST
                        <span
                            style={{
                                content: '""',
                                position: 'absolute',
                                bottom: '-4px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '40px',
                                height: '3px',
                                background: 'linear-gradient(90deg, #6a5acd, #ff7f50)',
                                borderRadius: '2px',
                            }}
                        />
                    </h6>



                </Grid>

            </Grid>

            {/* Modal for selected date details */}
            <Modal open={open} onClose={() => setOpen(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "#f7f9fc",
                        p: 3,
                        borderRadius: 3,
                        minWidth: 420,
                        maxWidth: 600,
                        maxHeight: "80vh",
                        overflowY: "auto",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            mb: 1,
                            fontWeight: 'bolder',
                            textAlign: "center",
                            fontFamily: "'Times New Roman', serif",
                            color: "#020b13ff",
                            fontSize: 13,
                            textTransform: "uppercase",
                        }}
                    >
                        {selectedDate ? `Stats for ${selectedDate.toDateString()}` : "Date Stats"}
                    </Typography>

                    {[
                        { title: "Quantities", metrics: quantityMetrics, bg: "#e6f0ff" },
                        { title: "Purchases", metrics: purchaseMetrics, bg: "#fff5e6" },
                        { title: "Sales", metrics: salesMetrics, bg: "#e6ffe6" },
                        { title: "Receipts", metrics: receiptsMetrics, bg: "#fff0f5" },
                    ].map((section, idx) => (
                        <Box key={idx} sx={{ mb: 1, borderRadius: 2, overflow: "hidden" }}>
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    mb: 0,
                                    p: 0.5,
                                    fontWeight: 600,
                                    backgroundColor: section.bg,
                                    color: "#1f2937",
                                    fontSize: 12,
                                    fontFamily: "'Times New Roman', serif",
                                    textTransform: "uppercase",
                                    textAlign: "center",
                                }}
                            >
                                {section.title}
                            </Typography>
                            <Paper variant="outlined" sx={{ borderRadius: 0, cursor: "pointer", }}>
                                <Table size="small">
                                    <TableBody>
                                        {section.metrics.map((m, i) => (
                                            <TableRow key={i} hover>
                                                <TableCell
                                                    sx={{
                                                        fontSize: 12,
                                                        fontWeight: 'bolder',
                                                        padding: "6px 8px",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    {m.label}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        textAlign: "right",
                                                        padding: "6px 8px",
                                                        color: "#111827",
                                                    }}
                                                >
                                                    {m.value}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Paper>
                        </Box>
                    ))}
                </Box>
            </Modal>

        </div >
    );
}

export default Home;



